import classNames from "classnames";
import CustomPageHeading from "shared/components/common/customPageHeading";
import CustomTextEditor from "shared/components/common/customTextEditor";
import styles from "./style.module.scss";

interface CommentsSectionProps {
  comments: string;
  internalComments: string;
  setComments: (value: string) => void;
  setInternalComments: (value: string) => void;
}

export const CommentsSection = ({
  comments,
  internalComments,
  setComments,
  setInternalComments,
}: CommentsSectionProps) => {
  return (
    <div
      className={classNames(
        styles.commentsContainer,
        "grid md:grid-cols-2 grid-cols-1 md:gap-6 gap-4",
      )}
    >
      <div className={classNames(styles.box, "flex flex-col gap-2")}>
        <CustomPageHeading
          size="medium"
          title="Comments"
          description="These comments will be visible to the client with this revision."
        />
        <CustomTextEditor
          value={comments}
          onChange={setComments}
          customContainerStyle={styles.commentsEditor}
          customToolbarStyle={styles.commentsToolbar}
          placeholder="Type your message here..."
        />
      </div>

      <div className={classNames(styles.box, "flex flex-col gap-2")}>
        <CustomPageHeading
          size="medium"
          title="Internal Comments"
          description="These Comments will be visible to the team with this revision."
        />
        <CustomTextEditor
          value={internalComments}
          onChange={setInternalComments}
          customContainerStyle={styles.commentsEditor}
          customToolbarStyle={styles.commentsToolbar}
          placeholder="Type your message here..."
        />
      </div>
    </div>
  );
};
